import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { environment } from '../../../environments/environment';
import { UserSession } from '@mem-shared/user-session';
import { CFHttpClient } from '../../shared/cf-http-client';
import { UtilService } from 'app/shared/util.service';

declare let ga: Function;
declare let trackGAEventGTM: Function;
let secureDimensionsLoaded = false;

const analyticsDetailsURL = environment.serviceSecuredURLs.analyticsDetailsURL; //'/mas/sec/getMemberAnalyticsDetails.json';

@Injectable()
export class GoogleAnalyticsService {
  constructor(
    private userSession: UserSession,
    private cfHttpClient: CFHttpClient,
    private utilService: UtilService,
    private router: Router
  ) {
    // Subscribe to router change events to capture virtual pageviews for google analytics
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && event.url !== '/fetchUserData') {
        //console.log('NavigationEnd:', event.url);
        this.submitPageViewToGA(event.url);
      }
    });
  }

  public submitEventToGA(ea, el) {
    if (location.protocol === 'file:') {
      // TBD: will be enabled later as part of native app implementation
      ga('myTracker.send', 'event', 'App Interaction', ea, el);
    } else if (
      typeof trackGAEventGTM === 'function' &&
      (location.protocol === 'http:' || location.protocol === 'https:')
    ) {
      trackGAEventGTM(ea, el);
    }
  }

  public submitPageViewToGA(virtualPageview: string) {
    if (this.userSession.isDataLoaded && !secureDimensionsLoaded) {
      this.setDataLayerWithMembDetails(virtualPageview);
    } else {
      this.sendToGA(virtualPageview);
    }
  }

  private setDataLayerWithMembDetails(virtualPageview: string) {
    //console.log('set secure custom dimensions');

    if (location.protocol === 'file:') {
       (<any>window).dataLayer.splice(0);
    }

    let analyticsData: any;

    this.cfHttpClient.get(analyticsDetailsURL).subscribe(
      (data: any) => {
        analyticsData = data.memberAnalyticsDetails;
        this.populateDataLayerObject(analyticsData);
        this.sendToGA(virtualPageview);
      },
      err => {
        return;
        // TBD: Need to think about error handling
      }
    );
  }

  private populateDataLayerObject(analyticsData: any) {
    if (analyticsData !== undefined) {
      let cookieDataObject: any;
      try {
        cookieDataObject = {};
        cookieDataObject.SBU = analyticsData.asuind;
        cookieDataObject.ACA = analyticsData.isACA;
        cookieDataObject.gender = analyticsData.genCode;
        cookieDataObject.insuranceType = analyticsData.insType;
        cookieDataObject.userType = analyticsData.covStsInd;
        cookieDataObject.ageRange = analyticsData.ageRange;
        cookieDataObject.accountID = analyticsData.accountId;
        cookieDataObject.jurisdiction = analyticsData.jurisdiction;
        cookieDataObject.isMemberInsured = analyticsData.isInsured;
        cookieDataObject.relationshipCode = analyticsData.relCode;
        cookieDataObject.enrollmentSystem = analyticsData.enrlSysCode;
        cookieDataObject.subscriberID = analyticsData.subscriberId;
        cookieDataObject.personID = analyticsData.personId;
        cookieDataObject.impersonation = analyticsData.isImpersonation;
        cookieDataObject.planType = analyticsData.prodVar;
        cookieDataObject.loggedIn = 'true';
        cookieDataObject.riskGroupIndicator = analyticsData.isASO;
        cookieDataObject.GroupID = analyticsData.groupId;
        cookieDataObject.SourceApplication = 'MemberWebPostLogin';
        cookieDataObject.blueRewardsMember = analyticsData.blueRewardsMember;
        cookieDataObject.blueRewardMemberStatus = analyticsData.blueRewardMemberStatus;
        cookieDataObject.accountName = analyticsData.accountName;
        cookieDataObject.groupName = analyticsData.groupName;
        cookieDataObject.application = this.utilService.getNativeOS();
        cookieDataObject.GUID = analyticsData.guid;

        (<any>window).dataLayer.push(cookieDataObject);

        secureDimensionsLoaded = true;
      } catch (error) {
        // handle error
      }
    }
  }

  private sendToGA(virtualPageview: string) {
    if (location.protocol === 'http:' || location.protocol === 'https:') {
      if ((<any>window).dataLayer) {
        (<any>window).dataLayer.push({ event: 'virtualPageview', virtualUrl: virtualPageview });
      }
    } else {
      // TBD: will be enabled later as part of native app implementation
      ga('myTracker.send', 'pageview', virtualPageview);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/google-analytics/google-analytics.service.ts